import { UserSetupDetails } from '../../../services/auth';
import { PasswordSetupData } from '../components/PasswordSetupForm';

export type SetupStep = 'setup-form' | 'mfa-qr' | 'mfa-code' | 'complete';

export type LoadingState =
  | 'idle'
  | 'loading-user-details'
  | 'validating-password'
  | 'submitting-password-setup'
  | 'submitting-sso-setup'
  | 'redirecting';

export enum SetupErrorType {
  INVALID_TOKEN = 'INVALID_TOKEN',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  NETWORK_ERROR = 'NETWORK_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export interface SetupError {
  type: SetupErrorType;
  message: string;
  retryable: boolean;
  statusCode: number;
}

export interface SetupState {
  loading: boolean;
  setupLoading: boolean;
  userDetails: UserSetupDetails | null;
  mfaLink: string | null;
  error: SetupError | null;
  currentStep: SetupStep;
  loadingState: LoadingState;
}

export interface SetupActions {
  handlePasswordSetup: (data: PasswordSetupData) => Promise<void>;
  handleSsoSetup: () => Promise<void>;
  handleMfaVerify: (code: string) => Promise<void>;
  setError: (error: SetupError | null) => void;
  setCurrentStep: (step: SetupStep) => void;
}
